import { convertListParams, getRepository, ListParam } from '@things-factory/shell'

import { TutorialRole } from '../../../entities'

export const tutorialRolesResolver = {
  async tutorialRoles(_: any, params: ListParam, context: ResolverContext) {
    const convertedParams = convertListParams(params)
    const [items, total] = await getRepository(TutorialRole).findAndCount({
      ...convertedParams,
      relations: ['domain', 'creator', 'updater']
    })
    return { items, total }
  }
}
